import { Component } from '@angular/core';

@Component({
  selector: 'motor-calculo-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {

}
